<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    const path = this.$route.query.jumpToPath;
    this.$router.push({
      name: path
    });
  },
  methods: {}
};
</script>
